export default __webpack_public_path__ + "static/media/1.8fa165c1.png";